import { Routes, Route } from "react-router-dom";
import Startup from "../pages/startup";
import DetailsPage from "../component/DetailsPage";
import Error from "../pages/error";
import Comingsoon from "../pages/comingsoon";
import Policies from "../pages/policies";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Startup />} />
      <Route path="/details/:id" element={<DetailsPage />} />
      <Route path="/error" element={<Error />} />
      <Route path="/comingsoon" element={<Comingsoon />} />
      <Route path="/policies" element={<Policies />} />
    </Routes>
  );
};

export default AppRoutes;
